import React from "react";
import { NavLink } from "react-router-dom";

export function Sidebar() {
  return (
    <aside className="sidebar" data-testid="sidebar" style={{ paddingTop: 8 }}>
      <div
        className="sidebar-brand"
        data-testid="sidebar-brand"
        style={{
          display: "block", padding: 0, margin: "0 0 8px",
          textAlign: "center",
        }}
      >
        <img
          src="/month-end-commander.png"
          alt="Month-End Commander"
          data-testid="sidebar-logo"
          style={{
            display: "block",
            width: "100%",
            maxWidth: 112,
            height: "auto",
            margin: "0 auto",
          }}
        />
      </div>

      <NavLink to="/" end className={({ isActive }) => "nav-item" + (isActive ? " active" : "")} data-testid="nav-hub">
        Hub
      </NavLink>
      <NavLink to="/accounts" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")} data-testid="nav-accounts">
        Accounts
      </NavLink>

      <div className="nav-section">Close Activities</div>
      <NavLink to="/recurring-journals" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")} data-testid="nav-recurring-journals">
        Recurring Journals
      </NavLink>

      <div className="nav-section">Registers</div>
      <NavLink to="/registers/caje" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")} data-testid="nav-caje-register">
        CAJE Register
      </NavLink>
      <NavLink to="/registers/bsje" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")} data-testid="nav-bsje-register">
        BSJE Register
      </NavLink>
      <NavLink to="/statement-library" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")} data-testid="nav-statement-library">
        Statement Library
      </NavLink>

      <div className="nav-section">Reports</div>
      <NavLink to="/reports" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")} data-testid="nav-reports">
        Reports
      </NavLink>
      <NavLink to="/audit/chain-check" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")} data-testid="nav-chain-check">
        Chain-Break Audit
      </NavLink>

      <div className="nav-section">Administration</div>
      <NavLink to="/admin/company-settings" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")} data-testid="nav-company-settings">
        Company Settings
      </NavLink>
      <NavLink to="/admin/engine-configuration" className={({ isActive }) => "nav-item" + (isActive ? " active" : "")} data-testid="nav-engine-configuration">
        Engine Configuration
      </NavLink>
    </aside>
  );
}
